import searchLogPerformanceConstants from "./SearchLogPerformanceConstants.js";
class SearchLogPerformanceActions {
  experimentSearchStart() {
    return {
      type: searchLogPerformanceConstants.EXP_SEARCH_LOAD_START,
      timestampMilliSeconds: performance.now()
    };
  }
  experimentSearchMainFunctionality() {
    return {
      type: searchLogPerformanceConstants.EXP_SEARCH_MAIN_FUNCTIONALITY,
      timestampMilliSeconds: performance.now()
    };
  }
  experimentSearchFullLoad() {
    return {
      type: searchLogPerformanceConstants.EXP_SEARCH_FULL_LOAD,
      timestampMilliSeconds: performance.now()
    };
  }
  flightSearchStart() {
    return {
      type: searchLogPerformanceConstants.FLIGHT_SEARCH_LOAD_START,
      timestampMilliSeconds: performance.now()
    };
  }
  flightSearchMainFunctionality() {
    return {
      type: searchLogPerformanceConstants.FLIGHT_SEARCH_MAIN_FUNCTIONALITY,
      timestampMilliSeconds: performance.now()
    };
  }
  flightSearchFullLoad() {
    return {
      type: searchLogPerformanceConstants.FLIGHT_SEARCH_FULL_LOAD,
      timestampMilliSeconds: performance.now()
    };
  }
}
const SearchLogPerformanceActions$1 = new SearchLogPerformanceActions();
export {
  SearchLogPerformanceActions,
  SearchLogPerformanceActions$1 as default
};
//# sourceMappingURL=SearchLogPerformanceActions.js.map
